import { logger } from '@tunasong/models'
import { circleOfFifths as createCircleOfFifths } from '@tunasong/music-lib'
import type { Scale } from '@tunasong/schemas'
import { useDesignTokens } from '@tunasong/ui-lib'
import type { FC } from 'react'
import React, { useEffect, useEffectEvent } from 'react'
import { drawCircleOfFifths } from './draw-circle.js'

export interface CircleOfFifthsProps {
  className?: string
  scale?: Scale
}

const canvasStyle: React.CSSProperties = {
  display: 'block',
  width: '100%',
  margin: 0,
  padding: 0,
}

export const CircleOfFifths: FC<CircleOfFifthsProps> = props => {
  const { className, scale = { root: 'C', type: 'major' } as Scale } = props
  const [canvas, setCanvas] = React.useState<HTMLCanvasElement | null>(null)
  const tokens = useDesignTokens()

  const draw = (canvas: HTMLCanvasElement, scale: Scale) => {
    const ctx = canvas.getContext('2d')
    if (!ctx) {
      return
    }
    const PIXEL_RATIO = window.devicePixelRatio
    canvas.width = canvas.offsetWidth * PIXEL_RATIO
    /** height === width */
    canvas.height = canvas.width
    ctx.setTransform(PIXEL_RATIO, 0, 0, PIXEL_RATIO, 0, 0)

    logger.debug(`Redraw to ${canvas.width}:${canvas.height}, offset: ${canvas.offsetHeight}:${canvas.offsetWidth}`)
    const circleOfFifths = createCircleOfFifths(scale)
    drawCircleOfFifths({
      ctx,
      tokens,
      width: canvas.offsetWidth,
      height: canvas.offsetHeight,
      circleOfFifths,
    })
  }

  const drawEvent = useEffectEvent((canvas: HTMLCanvasElement | null, scale: Scale) => {
    if (!(canvas && scale)) {
      return
    }
    draw(canvas, scale)
  })

  useEffect(() => {
    drawEvent(canvas, scale)

    /** Redraw on resize */
    const redraw = () => drawEvent(canvas, scale)
    window.addEventListener('resize', redraw)
    return () => {
      /** Unsubscribe on unmount */
      window.removeEventListener('resize', redraw)
    }
  }, [scale, canvas])

  if (!(scale.root && scale.type)) {
    return null
  }

  return <canvas style={canvasStyle} className={className} ref={setCanvas} width="300" height="300" />
}

export default CircleOfFifths
